import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const add = params => {
  return ApiService.multiPost(`Board/article`, params);
};

export const addKeywordInquiry = params => {
  return ApiService.multiPost(`Board/keywordInquiry`, params);
};

export const getById = params => {
  return ApiService.query(`Board/article/${params.id}`);
};

export const modifyById = params => {
  let id;
  for (var p of params) {
    let name = p[0];
    let value = p[1];
    if (name == 'id') {
      id = value;
    }
  }
  return ApiService.multiPost(`Board/article/${id}`, params);
};

export const removeById = params => {
  return ApiService.delete(`Board/article/${params.id}`, params);
};

export const search = params => {
  console.log('paramsparamsparamsparamsparamsparams');
  console.log(params);
  return ApiService.query(`Board/article/search?${stringify(params)}`);
};
export const searchKeywordInquiry = params => {
  return ApiService.query(`Board/keywordInquiry/search?${stringify(params)}`);
};
export const downloadKeywordInquiry = params => {
  return ApiService.file(`Board/keywordInquiry/excel?${stringify(params)}`);
};
